<template>
  <ion-page>
    <ion-header>
      <ion-toolbar>
        <ion-buttons slot="start">
          <ion-button fill="outline" color="medium" @click="cancelChanges">Cancelar</ion-button>
        </ion-buttons>
        <ion-title style="text-align:center;">{{ titulo || 'Escanear código' }}</ion-title>
      </ion-toolbar>
    </ion-header>

    <ion-content class="ion-padding" style="height: calc(100vh - 56px);">
      <div>
        <ScannerHtml5Qrcode
          ref="scanner"
          :elementId="elementId"
          :fps="15"
          :qrbox="{ width: 260, height: 260 }"
          :rememberLastUsedCamera="true"
          :showTorchButtonIfSupported="true"
          :autoStopOnSuccess="true"
          :autostart="true"
          :hideControls="true"
          @code-scanned="onCode"
        />
      </div>
    </ion-content>
  </ion-page>
</template>

<script>
import { defineComponent } from 'vue'
import { IonButton, IonButtons, IonContent, IonHeader, IonTitle, IonToolbar, IonPage } from '@ionic/vue'
import { modalController } from '@ionic/vue'
import ScannerHtml5Qrcode from '@/components/scanner/ScannerHtml5Qrcode.vue'
import { openToast } from '@/utilities/services/alert-utilities'

export default defineComponent({
  name: 'AppScanModal',
  components: { IonButton, IonButtons, IonContent, IonHeader, IonTitle, IonToolbar, IonPage, ScannerHtml5Qrcode },
  props: {
    titulo: String,
    elementId: { type: String, default: 'inventario-scan' }
  },
  methods: {
    async cancelChanges () {
      try {
        // parar escaneo explícitamente antes de cerrar
        if (this.$refs.scanner && this.$refs.scanner.stop) { await this.$refs.scanner.stop() }
        await modalController.dismiss(null, 'cancel')
      } catch (e) { /* noop */ }
    },
    async onCode (texto) {
      try {
        const valido = this.esCodigoValido(texto)
        if (!valido) {
          openToast('Código no válido', 'warning')
          return
        }
        // detenemos escaneo antes de cerrar para evitar errores del UI interno
        if (this.$refs.scanner && this.$refs.scanner.stop) { await this.$refs.scanner.stop() }
        await modalController.dismiss(texto, 'confirm')
      } catch (e) {
        openToast('Error al cerrar el escáner', 'danger')
      }
    },
    esCodigoValido (t) {
      if (!t || typeof t !== 'string') return false
      const txt = t.trim()
      // EAN-13 (13 dígitos), EAN-8 (8), CODE128 alfanumérico, QR (texto libre)
      const esDigits = /^\d{8,18}$/.test(txt)
      const esAlfa = /^[A-Za-z0-9\-_.]{4,64}$/.test(txt)
      return esDigits || esAlfa || txt.length > 0
    }
  }
  ,async unmounted() {
    // aseguramos el stop del escáner al desmontar el modal
    try { if (this.$refs.scanner && this.$refs.scanner.stop) { await this.$refs.scanner.stop() } } catch (e) { /* noop */ }
  }
})
</script>

<style scoped>
.ion-padding { display: flex; align-items: center; justify-content: center; }
</style>